/*
 * File: MeetingfulCss.js
 * Project: reports
 * Created Date: Monday July 30th 2018
 * Author: Austin Smith
 * -----
 * Last Modified: Monday, 30th July 2018 10:17:23 am
 * Modified By: Austin Smith (austin.smith918@yahoo.com>)
 * -----
 * Copyright (c) 2018 Teaming
 */

/* ======= All App File Include Here ======= */
// Vuetify Css
import "vuetify/dist/vuetify.css";

// Tour Css
import "vue-tour/dist/vue-tour.css";

// nprogress
import "nprogress/nprogress.css";

// Icon Files
import "../assets/themify-icons/themify-icons.css";

// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// animate css
import "../assets/animate.css";

// Global Scss File
import "../assets/scss/_style.scss";



// WEBPACK FOOTER //
// ./src/lib/MeetingfulCss.js